import React, { useRef } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import EntryForm from "../EntryForm";
import apiFetch from "../../api";

export default function AddTodo({ user_id, onAdded, size = "sm", label = "New task" }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const taskInput = useRef(null);
  const descriptionInput = useRef(null);
  const durationInput = useRef(null);
  const importanceInput = useRef(null);
  const anxietyInput = useRef(null);
  const repeatingInput = useRef(null);
  const date_dueInput = useRef(null);
  const today = new Date();
  const dateDefault = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}T${String(today.getHours()).padStart(2, "0")}:${String(today.getMinutes()).padStart(2, "0")}`;

  const handleSubmit = (event) => {
    event.preventDefault();
    const newTodo = {
      task: taskInput?.current?.value || "Untitled",
      description: descriptionInput.current?.value || "",
      duration: durationInput.current?.value || 30,
      importance: importanceInput.current?.value || 5,
      anxiety: anxietyInput.current?.value || 5,
      repeating: repeatingInput.current?.value || 0,
      date_due: date_dueInput.current?.value,
      user_id,
    };
    apiFetch(`/${user_id}/todo`, {
      method: "POST",
      body: JSON.stringify(newTodo),
    }).then(() => {
      onAdded?.();
      onClose();
    });
  };

  return (
    <>
      <Button size={size} colorScheme="gray" onClick={onOpen}>{label}</Button>
      <Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent mx={3}>
          <ModalHeader>New task</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <EntryForm
              taskInput={taskInput}
              descriptionInput={descriptionInput}
              durationInput={durationInput}
              importanceInput={importanceInput}
              anxietyInput={anxietyInput}
              repeatingInput={repeatingInput}
              date_dueInput={date_dueInput}
              task_default={null}
              description_default={null}
              duration_default={30}
              importance_default={5}
              anxiety_default={5}
              repeating_default={0}
              date_due_default={dateDefault}
            />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="gray" onClick={handleSubmit}>Add</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
